export default {
  nav: {
    technology: "ODF 기술",
    solutions: "솔루션",
    partnerships: "파트너십",
    about: "회사 소개",
    contact: "문의하기",
    home: "홈",
  },
  hero: {
    eyebrow: "차세대 ODF 솔루션",
    headline1: "혁신을,",
    headline2: "한 장의 필름에 담다.",
    copy: "NORTIS는 첨단 구강용해필름(Orally Dissolving Film, ODF) 제품을 현대적인 웰니스 브랜드와 국제 시장에 연결합니다. 편리한 제형과 신뢰할 수 있는 비즈니스 전문성을 결합합니다.",
    cta1: "ODF 기술 살펴보기",
    cta2: "NORTIS와 파트너 되기",
    trust: "현대적인 라이프스타일을 위해 설계. 글로벌 기회를 위해 구축.",
    scroll: "스크롤",
  },
  brandline: "진보된 전달 방식. 부담 없는 경험.",
  credibility: {
    title: "변화하는 세상을 위한 더 스마트한 제형.",
    copy: "구강용해필름은 정성껏 설계된 성분을 정제, 캡슐, 액상의 기존 복용 경험 없이 세련되고 간편하게 전달하는 방법을 제시합니다.",
  },
  whatIsOdf: {
    eyebrow: "제형 소개",
    title: "ODF란 무엇인가요?",
    copy: "ODF는 입안에서 간편하게 녹도록 설계된 초박형 구강 필름입니다. 콤팩트한 형태 덕분에 휴대성이 뛰어나고 사용하기 쉬운 웰니스 경험을 개발하는 브랜드에 현대적인 대안을 제공합니다.",
    benefits: [
      { title: "얇고 휴대가 간편한", desc: "주머니, 지갑, 가방 어디에나 부담 없이 휴대할 수 있는 초슬림 제형." },
      { title: "물 없이 사용", desc: "물이나 별도의 준비 없이 언제 어디서나 사용할 수 있도록 설계되었습니다." },
      { title: "정밀한 개별 포장", desc: "각 필름은 일관된 품질을 위해 낱개로 포장된 독립 단위입니다." },
      { title: "혁신을 위한 설계", desc: "현대적인 제품 콘셉트와 차별화된 브랜드 경험을 위한 유연한 기반입니다." },
    ],
  },
  whyNortis: {
    eyebrow: "NORTIS를 선택하는 이유",
    title: "제품 제형 그 이상, 완전한 시장 기회.",
    copy: "NORTIS는 ODF 혁신과 상업 시장을 잇는 가교입니다. 유망한 제품을 이를 확장할 수 있는 파트너와 연결합니다.",
    points: [
      { title: "ODF에 특화된 비즈니스 전문성", desc: "구강용해필름 카테고리와 그 상업적 역학에 전념합니다." },
      { title: "국제 소싱 및 시장 개발", desc: "여러 지역에서 기회를 발굴하고 시장 진출 경로를 구축합니다." },
      { title: "제품 및 브랜드 포지셔닝 지원", desc: "파트너가 ODF 콘셉트를 고객층과 판매 채널에 맞게 구성하도록 돕습니다." },
      { title: "유연한 B2B 파트너십 모델", desc: "유통, 자체 브랜드(PB), 시장 개발 — 귀사의 목표에 맞춰 구성합니다." },
      { title: "품질 중심의 제품 선정", desc: "적합성, 문서, 시장 준비 상태를 원칙에 따라 평가합니다." },
      { title: "장기적인 관계", desc: "지속 가능하고 누적되는 비즈니스 성장을 위한 파트너십을 구축합니다." },
    ],
  },
  solutions: {
    eyebrow: "솔루션 포트폴리오",
    title: "현대적인 삶을 중심으로 설계된 포트폴리오.",
    copy: "NORTIS가 전 세계 파트너 및 시장과 함께 개발하는 솔루션 카테고리를 살펴보세요.",
    viewAll: "모든 솔루션 보기",
    requestInfo: "제품 정보 요청",
    possibilitiesLabel: "개발 가능성",
    positioningLabel: "상업적 포지셔닝",
    availabilityLabel: "시장 공급 현황",
    targetLabel: "타깃 시장",
    docLabel: "문서 준비 상태",
    sheetLabel: "제품 정보 자료",
    sheetOnRequest: "요청 시 제공",
    demoBadge: "데모 콘셉트",
    filterAll: "전체",
    pageTitle: "솔루션",
    pageSub: "필터링이 가능한 ODF 솔루션 카테고리 포트폴리오입니다. 파트너십이 발전함에 따라 실제 제품을 추가할 수 있도록 구성되어 있습니다.",
    demoNote: "아래 항목은 각 카테고리의 방향성을 보여주는 데모 콘셉트입니다. 실제 상용 제품은 진행 중인 파트너십을 통해 소개됩니다.",
  },
  comparison: {
    eyebrow: "제형 비교",
    title: "필름 제형, 어떻게 다를까요?",
    copy: "일상적인 제형들의 실용적 특성을 중립적인 시각으로 비교합니다.",
    note: "본 표는 제형의 실용적 특성만을 중립적으로 비교한 것으로, 임상적 성능이나 효능에 대한 주장이 아닙니다.",
    formats: ["ODF 필름", "정제", "캡슐", "액상"],
    rows: [
      { label: "휴대성", values: [2, 2, 2, 0] },
      { label: "물 없이 사용", values: [2, 0, 0, 1] },
      { label: "1회분 개별 포장", values: [2, 2, 2, 0] },
      { label: "보관 편의성", values: [2, 2, 1, 0] },
      { label: "이동 중에도 부담 없는 사용", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "파트너십 모델",
    title: "NORTIS와 함께 성장하는 세 가지 방법.",
    cta: "파트너십 상담하기",
    items: [
      { title: "유통", desc: "엄선된 ODF 제품을 새로운 지역과 유통 네트워크로 확장하세요." },
      { title: "자체 브랜드(PB)", desc: "귀사의 브랜드로 차별화된 ODF 콘셉트를 개발하세요." },
      { title: "시장 개발", desc: "NORTIS와 함께 제품 포지셔닝, 론칭 전략, 장기적인 시장 입지를 구축하세요." },
    ],
  },
  timeline: {
    eyebrow: "협업 프로세스",
    title: "첫 대화에서 시장 성장까지.",
    steps: [
      { title: "기회 발굴", desc: "귀사의 목표와 시장, 그에 맞는 ODF 콘셉트를 함께 탐색합니다." },
      { title: "제품·시장 정합성 검토", desc: "적합한 제품을 적합한 상업적 환경과 연결합니다." },
      { title: "상업적 평가", desc: "조건, 물량, 현실적인 비즈니스 프레임워크를 설계합니다." },
      { title: "컴플라이언스 및 론칭 준비", desc: "출시 전에 문서와 시장 요건을 검토합니다." },
      { title: "유통 및 성장", desc: "출시, 확장, 그리고 파트너십의 장기적 성장을 지원합니다." },
    ],
  },
  quality: {
    eyebrow: "품질과 책임",
    title: "품질은 올바른 질문에서 시작됩니다.",
    copy: "NORTIS는 모든 잠재적 파트너십 과정에서 제품 적합성, 문서, 상업적 준비 상태, 시장 요건을 평가합니다. 제품의 공급 가능 여부와 규제상 지위는 국가에 따라 다를 수 있습니다.",
    placeholder: "검증된 품질 문서와 인증은 파트너십이 진전됨에 따라 이곳에 게시됩니다.",
  },
  global: {
    eyebrow: "글로벌 비전",
    title: "국제 협력을 위해 태어났습니다",
    copy: "변화하는 글로벌 시장에서 의미 있는 ODF 기회를 발굴하기 위해 브랜드, 공급업체, 유통사, 비즈니스 파트너와 협력합니다.",
  },
  finalCta: {
    title: "구강 웰니스의 다음 세대를 함께 만들어 갑시다.",
    copy: "유통, 자체 브랜드, 새로운 ODF 제품 콘셉트 — 무엇을 검토하고 계시든, NORTIS는 대화를 시작할 준비가 되어 있습니다.",
    cta: "상담 시작하기",
  },
  footer: {
    desc: "NORTIS는 혁신적인 ODF 제품을 전 세계 브랜드, 파트너, 시장과 연결합니다.",
    nav: "사이트맵",
    legal: "법적 고지",
    privacy: "개인정보 처리방침",
    terms: "이용약관",
    language: "언어",
    disclaimer: "제품의 공급 가능 여부, 제형, 분류 및 규제상 지위는 국가에 따라 다를 수 있습니다. 본 웹사이트의 정보는 상업적·일반적 정보 제공을 목적으로 하며 의학적 조언에 해당하지 않습니다.",
    rights: "모든 권리 보유.",
  },
  tech: {
    eyebrow: "ODF 기술",
    title: "얇음의 과학.",
    sub: "구강용해필름에 대한 교육적 개요 — 제형, 사용 경험, 그리고 그것이 여는 상업적 가능성.",
    what: {
      title: "구강용해필름이란?",
      copy: "구강용해필름(ODF)은 입안에서 간편하게 녹도록 설계된 초박형 시트입니다. 정제를 삼키거나 액상을 계량하는 대신, 필름 한 장을 입에 올려 녹기를 기다리면 됩니다. 놀랍도록 콤팩트한 제형이 선사하는 조용하고 현대적인 경험입니다.",
    },
    structure: {
      title: "필름의 기본 구조",
      copy: "개념적으로 ODF는 구조를 지탱하는 필름 베이스, 배합 성분을 담는 캐리어 매트릭스, 그리고 맛과 질감을 결정하는 감각 레이어로 구성됩니다. 다이어그램에 마우스를 올리거나 터치하면 개념적 레이어가 분리됩니다.",
      note: "설명을 위한 개념도입니다.",
      layers: [
        { title: "감각 레이어", desc: "맛, 질감, 용해 경험을 결정합니다." },
        { title: "캐리어 매트릭스", desc: "정성껏 배합된 성분을 필름 안에 담습니다." },
        { title: "구조 베이스", desc: "필름에 견고함, 얇음, 안정성을 부여합니다." },
      ],
    },
    experience: {
      title: "사용 경험",
      copy: "물도, 계량도, 번거로움도 없습니다. 필름은 조용히 녹기 때문에 여행 중에도, 업무 중에도, 이동 중에도 자연스럽게 사용할 수 있습니다. 현대 소비자에게는 제형 자체가 브랜드 경험의 일부가 됩니다.",
    },
    portability: {
      title: "휴대성과 패키징 잠재력",
      copy: "낱개 필름은 슬림한 파우치, 세련된 멀티팩, 콤팩트한 디스펜서 등으로 선보일 수 있습니다. 현대적인 소매 매대는 물론 D2C 언박싱 경험에도 잘 어울리는 형태입니다.",
    },
    development: {
      title: "제품 개발 가능성",
      copy: "필름 제형은 일상적인 웰니스 루틴부터 타깃형 라이프스타일 포지셔닝까지 폭넓은 제품 콘셉트를 지원하며, 경쟁이 치열한 카테고리에서 브랜드가 차별화할 수 있는 여지를 제공합니다.",
    },
    commercial: {
      title: "상업적 활용 분야",
      copy: "ODF 콘셉트는 웰니스, 이너뷰티, 에너지, 수면, 기능성 성분 카테고리에서 개발되고 있습니다. 모두 편의성과 프리미엄 경험이 구매 결정을 좌우하는 채널입니다.",
    },
    regulatory: {
      title: "시장 및 규제 고려사항",
      copy: "필름 제품의 분류와 요건은 국가와 제형에 따라 다릅니다. NORTIS는 각 시장에 개별적으로 접근하며, 상용화에 앞서 파트너와 함께 문서와 규제 환경을 검토합니다.",
    },
    cta: "기술 정보 요청",
  },
  partnership: {
    eyebrow: "자체 브랜드(PB)와 유통",
    title: "두 가지 길, 하나의 파트너십 기준.",
    sub: "NORTIS는 상업적 협력을 두 가지 핵심 모델을 중심으로 구성합니다. 두 모델 모두 명확성, 속도, 장기적 성장을 위해 설계되었습니다.",
    plTitle: "자체 브랜드(PB)",
    plDesc: "콘셉트에서 매대까지의 여정을 NORTIS가 조율하는 가운데, 귀사의 브랜드로 차별화된 ODF 콘셉트를 개발하세요.",
    plSteps: ["콘셉트 평가", "제품 선정", "브랜딩·패키징 조율", "문서 검토", "시장 론칭 준비", "상업적 확장"],
    distTitle: "유통",
    distDesc: "각 단계마다 체계적인 지원을 받으며, 엄선된 ODF 제품을 귀사의 지역과 유통 네트워크로 확장하세요.",
    distSteps: ["지역 평가", "포트폴리오 정합성 검토", "상업 조건", "시장 진입 계획", "론칭 지원", "장기적 성장"],
    formTitle: "파트너십 문의 시작하기",
    formSub: "귀사의 목표를 알려주시면 저희 팀이 다음 단계를 안내해 드리겠습니다.",
  },
  about: {
    eyebrow: "NORTIS 소개",
    title: "내일을 만드는 제형에 집중합니다.",
    copy: "NORTIS는 유망한 ODF 혁신을 의미 있는 상용 제품으로 전환할 수 있는 브랜드, 파트너, 시장과 연결하기 위해 설립되었습니다. 기업가적 속도, 국제적 시각, 그리고 장기적 파트너십에 대한 원칙 있는 접근을 결합합니다.",
    positioning: "NORTIS는 혁신적인 ODF 제품을 전 세계 브랜드, 파트너, 시장과 연결합니다.",
    principlesTitle: "우리의 원칙",
    principles: [
      { title: "정밀함", desc: "제품 평가부터 파트너 커뮤니케이션까지, 모든 디테일에 대한 세심함." },
      { title: "신뢰", desc: "투명한 기대치와 반드시 지키고자 하는 약속." },
      { title: "전진", desc: "발전과 현대적인 제형을 향한 확고한 지향." },
      { title: "파트너십", desc: "분기가 아닌 수년에 걸쳐 가치를 쌓아가는 관계." },
      { title: "글로벌 관점", desc: "국경, 시장, 소비 문화를 넘어 사고하는 것." },
    ],
  },
  contact: {
    eyebrow: "문의",
    title: "대화를 시작해 볼까요?",
    sub: "관심 분야에 대해 간단히 알려주시면 저희 팀이 연락드리겠습니다.",
    name: "성함",
    company: "회사명",
    email: "업무용 이메일",
    country: "국가",
    website: "웹사이트",
    interest: "관심 있는 파트너십",
    market: "예상 시장 또는 지역",
    message: "메시지",
    consent: "본 문의에 대한 응대를 위해 NORTIS가 내 정보를 보관하는 것에 동의합니다.",
    submit: "메시지 보내기",
    sending: "전송 중…",
    successTitle: "감사합니다. 메시지가 접수되었습니다.",
    successCopy: "저희 팀이 문의 내용을 검토한 후 곧 연락드리겠습니다.",
    successAnother: "다른 메시지 보내기",
    errorRequired: "필수 입력 항목입니다.",
    errorEmail: "올바른 업무용 이메일 주소를 입력해 주세요.",
    errorConsent: "양식을 제출하려면 동의가 필요합니다.",
    errorSubmit: "오류가 발생했습니다. 다시 시도해 주세요.",
    optional: "선택",
    interests: {
      distribution: "유통",
      privateLabel: "자체 브랜드(PB)",
      sourcing: "제품 소싱",
      marketDev: "시장 개발",
      general: "일반 파트너십",
      product: "제품 정보",
      technical: "기술 정보",
    },
    selectPlaceholder: "옵션을 선택하세요",
  },
  legal: {
    privacyTitle: "개인정보 처리방침",
    termsTitle: "이용약관",
    updated: "최종 업데이트",
    privacy: [
      { h: "1. 개요", p: "본 개인정보 처리방침은 NORTIS가 본 웹사이트를 통해 제출된 정보를 어떻게 수집, 이용, 보호하는지 설명합니다. 당사는 비즈니스 연락처 정보를 책임감 있고 투명하게 처리할 것을 약속합니다." },
      { h: "2. 수집하는 정보", p: "문의 또는 파트너십 양식을 제출하시면 성함, 회사명, 업무용 이메일, 국가, 웹사이트, 관심 분야, 메시지 내용 등 제공해 주신 정보를 수집합니다." },
      { h: "3. 정보의 이용", p: "제출된 정보는 문의에 대한 응대, 잠재적 상업 협력의 평가, 관련 파트너십 사안에 대한 커뮤니케이션 목적으로만 이용됩니다. 개인정보를 판매하지 않습니다." },
      { h: "4. 데이터 보관 및 보안", p: "양식 제출 내용은 당사 애플리케이션 데이터베이스에 안전하게 보관됩니다. 접근은 문의 응대에 필요한 담당자로 제한됩니다. 보관된 데이터를 보호하기 위해 합리적인 기술적 조치를 취합니다." },
      { h: "5. 데이터 보유 기간", p: "문의 데이터는 비즈니스 관계 관리에 필요한 기간 또는 관련 법령이 요구하는 기간 동안 보유합니다. 당사에 연락하여 데이터 삭제를 요청하실 수 있습니다." },
      { h: "6. 귀하의 권리", p: "관할 법역에 따라 당사가 보유한 귀하의 개인정보에 대한 열람, 정정, 삭제를 요구할 권리가 있을 수 있습니다. 이러한 권리를 행사하시려면 웹사이트를 통해 문의해 주세요." },
      { h: "7. 방침의 변경", p: "본 개인정보 처리방침은 수시로 업데이트될 수 있습니다. 중요한 변경 사항은 개정 일자와 함께 본 페이지에 반영됩니다." },
    ],
    terms: [
      { h: "1. 약관의 동의", p: "본 웹사이트에 접속하고 이용함으로써 귀하는 본 이용약관에 동의하는 것으로 간주됩니다. 동의하지 않으시면 사이트 이용을 중단해 주시기 바랍니다." },
      { h: "2. 정보 제공 목적", p: "본 웹사이트의 콘텐츠는 상업적·일반적 정보 제공만을 목적으로 합니다. 의학적, 법적 또는 규제 관련 조언에 해당하지 않으며, 어떠한 콘텐츠도 제품 효능에 대한 주장으로 해석되어서는 안 됩니다." },
      { h: "3. 제품 공급 가능성", p: "제품의 공급 가능 여부, 제형, 분류 및 규제상 지위는 국가에 따라 다를 수 있습니다. 본 웹사이트의 어떠한 내용도 특정 법역에서의 제품 판매 제안에 해당하지 않습니다." },
      { h: "4. 지식재산권", p: "NORTIS라는 명칭, 시각적 아이덴티티 및 웹사이트 콘텐츠는 NORTIS의 자산입니다. 사전 서면 허가 없이 사이트 콘텐츠를 복제하거나 배포할 수 없습니다." },
      { h: "5. 책임의 제한", p: "NORTIS는 웹사이트 정보의 정확성을 유지하기 위해 합리적인 노력을 기울이지만, 그 완전성을 보증하지 않습니다. 법이 허용하는 범위 내에서, NORTIS는 웹사이트 콘텐츠에 근거하여 내려진 결정에 대해 책임지지 않습니다." },
      { h: "6. 제3자 링크", p: "본 웹사이트에는 제3자 리소스로 연결되는 링크가 포함될 수 있습니다. NORTIS는 외부 사이트의 콘텐츠나 운영에 대해 책임지지 않습니다." },
      { h: "7. 약관의 효력", p: "본 약관은 주기적으로 업데이트될 수 있습니다. 웹사이트를 계속 이용하는 것은 최신 버전에 대한 동의를 의미합니다." },
    ],
  },
  seo: {
    home: { title: "NORTIS — 첨단 ODF 솔루션 | 구강용해필름 파트너", desc: "NORTIS는 혁신적인 구강용해필름(ODF) 제품을 전 세계 브랜드, 파트너, 시장과 연결합니다. 유통, 자체 브랜드(PB), 시장 개발." },
    tech: { title: "ODF 기술 — NORTIS", desc: "구강용해필름 기술에 대한 교육적 개요: 제형, 구조, 사용 경험, 상업적 가능성." },
    solutions: { title: "ODF 솔루션 포트폴리오 — NORTIS", desc: "ODF 솔루션 카테고리를 살펴보세요: 데일리 웰니스, 에너지, 뷰티, 수면, 기능성 성분, 맞춤형 자체 브랜드 콘셉트." },
    partnership: { title: "자체 브랜드(PB)와 유통 — NORTIS", desc: "ODF 제품의 유통, 자체 브랜드, 시장 개발 모델을 통해 NORTIS와 파트너가 되세요." },
    about: { title: "NORTIS 소개 — 내일을 만드는 제형에 집중", desc: "NORTIS는 유망한 ODF 혁신을 상용 제품으로 전환할 수 있는 브랜드, 파트너, 시장과 연결합니다." },
    contact: { title: "NORTIS 문의 — 대화 시작하기", desc: "ODF 유통, 자체 브랜드, 소싱, 시장 개발에 대해 NORTIS 팀에 문의하세요." },
    privacy: { title: "개인정보 처리방침 — NORTIS", desc: "NORTIS가 본 웹사이트를 통해 제출된 정보를 수집, 이용, 보호하는 방법." },
    terms: { title: "이용약관 — NORTIS", desc: "NORTIS 웹사이트 및 정보 콘텐츠 이용에 적용되는 약관." },
  },
  a11y: {
    mainNav: "주 내비게이션",
    mobileNav: "모바일 내비게이션",
    homeLink: "NORTIS 홈",
    openMenu: "메뉴 열기",
    closeMenu: "메뉴 닫기",
    langSelector: "언어 선택",
    filmDiagram: "인터랙티브 필름 레이어 다이어그램",
    linkedinLabel: "LinkedIn의 NORTIS",
    techImageAlt: "겹겹이 쌓인 추상적인 필름 시트",
    yes: "예",
    partial: "일부",
    no: "아니요",
    filters: "솔루션 필터",
  },
  solutionsData: {
    "daily-wellness": {
      name: "데일리 웰니스",
      desc: "현대적인 아침·저녁 루틴에 자연스럽게 스며들도록 설계된 일상용 필름 콘셉트.",
      possibilities: ["루틴 기반 제품 라인", "구독 모델에 적합한 형태", "미니멀한 프리미엄 패키지"],
      positioning: "부담 없이 매일 꾸준히 챙기고 싶은 소비자를 위한 포지셔닝.",
      availability: "파트너와 개발 중",
      targetMarket: "웰니스·라이프스타일 리테일",
      docStatus: "시장별로 준비",
    },
    "energy-performance": {
      name: "에너지 & 퍼포먼스",
      desc: "운동 전, 여행 전, 바쁜 하루 전 — 추진력을 중시하는 소비자를 위한 온더고 콘셉트.",
      possibilities: ["활동 전 포지셔닝", "콤팩트한 멀티팩 형태", "대담하고 현대적인 브랜드 언어"],
      positioning: "속도와 편의성을 우선하는 소비 순간을 위해 설계.",
      availability: "파트너와 개발 중",
      targetMarket: "액티브 라이프스타일·스포츠 채널",
      docStatus: "시장별로 준비",
    },
    "beauty-aging": {
      name: "뷰티 & 헬시 에이징",
      desc: "경험과 미학이 중요한 이너뷰티 카테고리를 위한 우아한 필름 콘셉트.",
      possibilities: ["프리미엄 뷰티 포지셔닝", "선물용 패키지 콘셉트", "리추얼 중심의 브랜드 스토리텔링"],
      positioning: "일상의 뷰티 리추얼을 한 단계 끌어올리는 브랜드를 위한 세련된 제형.",
      availability: "파트너와 개발 중",
      targetMarket: "이너뷰티·프리미엄 리테일",
      docStatus: "시장별로 준비",
    },
    "sleep-relaxation": {
      name: "수면 & 릴랙세이션",
      desc: "하루의 끝, 단순함을 중심에 둔 차분한 저녁용 콘셉트.",
      possibilities: ["저녁 리추얼 포지셔닝", "머리맡에 두기 좋은 미니멀한 형태", "마음을 편안하게 하는 감각적 디자인"],
      positioning: "휴식 전의 고요한 순간을 위해 만들어졌습니다.",
      availability: "파트너와 개발 중",
      targetMarket: "나이트 웰니스·약국 리테일",
      docStatus: "시장별로 준비",
    },
    "vitamins-functional": {
      name: "비타민 & 기능성 성분",
      desc: "검증된 기능성 성분을 중심으로, 정밀하고 현대적인 제형으로 선보이는 필름 콘셉트.",
      possibilities: ["성분 중심의 제품군", "명확하고 정직한 라벨 디자인", "제형을 통한 차별화"],
      positioning: "이미 자리 잡은 성분 카테고리에서의 현대적인 대안.",
      availability: "파트너와 개발 중",
      targetMarket: "뉴트라수티컬·기능성 리테일",
      docStatus: "시장별로 준비",
    },
    "custom-private-label": {
      name: "맞춤형 & 자체 브랜드(PB) 콘셉트",
      desc: "백지 캔버스: 아이디어부터 론칭까지, 파트너의 브랜드로 개발되는 맞춤형 ODF 콘셉트.",
      possibilities: ["완전 맞춤형 콘셉트 개발", "브랜드·패키지 조율", "론칭 및 확장 지원"],
      positioning: "누가 봐도 자사의 것이라 할 수 있는, 차별화된 제품을 원하는 파트너를 위해.",
      availability: "제안 접수 중",
      targetMarket: "브랜드 오너·리테일러",
      docStatus: "프로젝트별로 정의",
    },
  },
};
